import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import DeleteIcon from '@mui/icons-material/Delete';

import DatePicker from '../../../../AutoOpenDatePicker';
import { Field } from 'redux-form';
import { format, parseISO, isValid } from 'date-fns';
import i18n from 'i18next';

import { __SetFilter } from '../../../../../actions/AsyncTable';
import store from '../../../../../store';

/* ================= redux-form adapter ================= */

const RenderDatePicker = ({ input, label, meta: { touched, error }, ...rest }) => {
    const value = input.value?.from ? parseISO(input.value.from) : null;

    return (
        <DatePicker
            {...rest}
            value={isValid(value) ? value : null}
            format="dd/MM/yyyy"
            maxDate={input.name === 'createdMoneyBoxDate' ? new Date() : undefined}
            onChange={date => {
                if (date && isValid(date)) {
                    const formatted = format(date, 'yyyy-MM-dd');
                    input.onChange({ from: formatted, to: formatted });
                } else {
                    input.onChange(null);
                }
            }}
            slotProps={{
                textField: {
                    fullWidth: true,
                    variant: 'outlined',
                    label,
                    error: touched && Boolean(error),
                    helperText: touched && error && (error.from || error.to),
                },
            }}
        />
    );
};

/* ================= component ================= */

export default function DateFilterCard(item) {
    return (
        <Card>
            <CardContent>
                <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                    <Typography variant="h6">{i18n.t(item.label)}</Typography>

                    <IconButton onClick={() => __SetFilter()(store.dispatch, store.getState)(item)}>
                        <DeleteIcon />
                    </IconButton>
                </Stack>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box sx={{ width: 300 }}>
                            <Field name={item.code} component={RenderDatePicker} label={i18n.t('filter.choose_day')} />
                        </Box>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}
